
export const checkConsultationDuration = val => [6, 10, 12, 15, 20, 30, 60].includes(val)

// export const isValidConsultationDuration = value => ['0', '6', '10', '12', '15', '20', '30', '60'].includes(value)
